/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { path } from 'ramda';
import Oops from '../shared/Oops';
import Loading from '../shared/Loading';
import { Accordion } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/minimal-example.css';

import FAQuestion from '../landing/FAQuestion';
import Steps from '../shared/Steps';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import CheckpointDown from '../../images/svgs/down.svg';
import Checkpoint from '../../images/svgs/checkpoint.svg';
import FinancialAdvisors from '../shared/FinancialAdvisors';
import { mp } from '../../constants/utils';
import Icon from '../shared/Icon';
// eslint-disable-next-line no-unused-vars
import {
  FinancialInstrument,
  FAKE_RESPONSE_SHORT,
  FAKE_RESPONSE_BIG_FISH,
} from '../../constants/questionnaires';
import { palette } from '../../constants/styles';
import Button from '../shared/Button';
import ProgressBar from '../shared/ProgressBar';
import { FlowHeader } from './styles';
import Title from '../shared/Title';
import Text from '../shared/Text';
import QuestionByType from '../shared/QuestionInputs/QuestionByType';
import {
  StyledCustomDivision,
  StyledFinancialVehicle,
  StyledFinancialVehiclesList,
  StyledSummary,
  StyledDisclaimerBullets,
  StyledResultsDescription,
  StyledBold,
  StyledCongratsTitle,
  StyledUnderline,
  StyledResultTitle,
  StyledLink,
  WhiteLogo,
  StyledFooter,
  StyledResults,
  FirstSection,
} from '../shared/resultsStyles';
import ConvertingModal from '../shared/ConvertingModal';
import CTA from '../shared/CTA';
import ResultSubsection from '../shared/ResultSubsection';
import Contact from '../shared/Contact';
import QuestionSection from '../shared/QuestionSection';
import {phoneNumber} from "../../constants/constants";

const GoalResult = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin: 10px 0;
`;

const SavingMessage = styled.li`
  list-style-type: none;
  margin: 0;
  padding: 7px 5px;
  background-color: white;
  position: relative;
  margin: 15px 0px 15px 5px;
  width: fit-content;
  // border: 1px solid ${palette.secondaryColor};
  // border-radius: 8px;
  z-index: 20;
`;

const GoalResults = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  border: none;
  border-left: 2px dashed ${palette.primaryColor};
  margin-left: 10px;
`;

const GoalAchievementMessage = styled.li`
  list-style-type: none;
  background: url(${Checkpoint}) no-repeat left center;
  margin: 0;
  padding: 0;
  margin-left: -11px;
  padding-left: 28px;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: white;
  position: relative;
  z-index: 20;

  ${({ start }) =>
    start &&
    css`
      background: url(${CheckpointDown}) no-repeat left center;
      margin-bottom: -13px;
    `}
`;

const StyledCaption = css`
  color: rgba(121, 121, 121, 1);
  margin-left: 18px;
`;

const Blank1 = styled.div`
  height: 20px;
  width: 20px;
  background-color: white;
  position: absolute;
  margin-left: -12px;
`;

const Blank2 = styled.div`
  height: 50px;
  width: 20px;
  background-color: white;
  position: absolute;
  margin-left: -12px;
  margin-top: -37px;
`;

const StyledFinancialMap = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const generateCustomMessage = (age, currentSavings, goals) => {
  let goalsText = '';
  for (let i = 0; i < goals.length; i += 1) {
    goalsText += `A mis ${age + goals[i].years_to_expense} quiero lograr ${goals[i].name.replace(
      /_/g,
      ' ',
    )} de $${goals[i].money_to_save.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}\n`;
  }
  return `Hola 👋 me gustaría platicar con un experto para lograr mis metas.\n\nTengo ${age} años y tengo ahorrados $${currentSavings} pesos\n${goalsText}`;
};

class Results extends Component {
  state = {
    customMessage: '',
    openConvertingModal: false,
  };

  componentWillReceiveProps(nextProps) {
    if (!nextProps.plan.data) {
      mp('Metas | Resultados | Error');
    } else {
      mp('Metas | Resultados | Entra');
      this.setState({
        customMessage: generateCustomMessage(
          nextProps.plan.data.age,
          nextProps.plan.data.current_savings,
          nextProps.plan.data.financial_goals,
        ),
      });
    }
  }

  componentDidUpdate = () => {
    window.onbeforeunload = () => {
      mp('Metas | Resultados | Se va');
    };
  };

  toggleModalBank = () => {
    const { openModalBank } = this.state;
    this.setState({ openModalBank: !openModalBank });
  };

  toggleModalCetes = () => {
    const { openModalCetes } = this.state;
    this.setState({ openModalCetes: !openModalCetes });
  };

  toggleModalBolsaDeValores = () => {
    const { openModalBolsaDeValores } = this.state;
    this.setState({ openModalBolsaDeValores: !openModalBolsaDeValores });
  };

  toggleModalFondoDeAhorro = () => {
    const { openModalFondoDeAhorro } = this.state;
    this.setState({ openModalFondoDeAhorro: !openModalFondoDeAhorro });
  };

  render() {
    const { plan, failed } = this.props;
    const { customMessage, openConvertingModal } = this.state;

    const goals = path(['plan', 'data', 'financial_goals'], this.props) || [];

    // eslint-disable-next-line no-nested-ternary
    return plan.data && !failed ? (
      <Fragment>
        <ConvertingModal
          closeCallback={() => {
            this.setState({ openConvertingModal: !openConvertingModal });
          }}
          show={openConvertingModal}
          toolName="Savings"
          customMessage={customMessage}
          stepsAction={[
            {
              content: (
                <Fragment>
                  Registrate
                  <Link
                    style={{ color: 'blue', marginLeft: '0.3em' }}
                    to={{
                      pathname: '/registro',
                      state: {
                        customMessage,
                      },
                    }}
                  >
                    aquí
                  </Link>
                </Fragment>
              ),
            },
            { content: 'Conoce tus opciones' },
            { content: 'Elige tu opción preferida' },
          ]}
        />
        <StyledResults>
          {plan.data.savings_periods.length > 0 ? (
            <Fragment>
              <FlowHeader>
                <Link to="/" onClick={this.forceUpdate}>
                  <WhiteLogo src={FinautaWhiteLogo} id="logo" />
                </Link>
                <ProgressBar current={10} total={10} />
              </FlowHeader>
              <FirstSection>
                <Accordion
                  accordion={false}
                  style={{ width: '100%', marginBottom: '10px', maxWidth: '750px' }}
                >
                  <FAQuestion
                    question={{
                      question: 'Tus metas',
                      answer: (
                        <StyledSummary>
                          <Text type="body1">
                            Tienes <StyledBold>{plan.data.age} años</StyledBold>, cuentas con{' '}
                            <StyledBold>
                              <NumberFormat
                                value={plan.data.current_savings}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                              />
                            </StyledBold>{' '}
                            ahorrados y quieres lograr:
                          </Text>
                          <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
                            {goals.map((goal) => {
                              const expectedAge = plan.data.age + goal.years_to_expense;
                              const goalId = goal._id; // eslint-disable-line
                              return (
                                <li key={`goal-description-${goalId}`}>
                                  <Text type="body1">
                                    <StyledBold>{goal.name.replace(/_/g, ' ')}</StyledBold> de{' '}
                                    <StyledBold>
                                      <NumberFormat
                                        value={Math.floor(goal.money_required)}
                                        displayType="text"
                                        thousandSeparator
                                        prefix="$"
                                      />
                                    </StyledBold>{' '}
                                    a tus{' '}
                                    <StyledBold>
                                      <NumberFormat value={expectedAge} displayType="text" />
                                    </StyledBold>
                                  </Text>
                                </li>
                              );
                            })}
                          </ul>
                        </StyledSummary>
                      ),
                    }}
                    borderBottom
                  />
                </Accordion>
                <StyledFinancialMap>
                  <Title level={2} styles={StyledResultTitle} style={{ lineHeight: '1.5' }} medium>
                    Tu plan ahorrando en:
                    <Formik>
                      {(props) => (
                        <Form style={{ display: 'inline-block' }}>
                          <QuestionByType
                            type={FinancialInstrument.type}
                            question={{
                              ...FinancialInstrument,
                              id: 'financial-instrument',
                              index: 0,
                            }}
                            form={props}
                            onQuestionChange={(selection) => {
                              this.setState({ currentSelection: selection.value });
                            }}
                            selectorStyle={{ marginBottom: '-10px', maxHeight: '35px' }}
                          />
                        </Form>
                      )}
                    </Formik>
                  </Title>
                  <GoalResults>
                    <Blank1 />
                    <GoalResult>
                      <GoalAchievementMessage start="true">
                        A tus <StyledBold>{plan.data.age} años</StyledBold> tienes{' '}
                        <StyledBold>
                          {
                            <NumberFormat
                              value={plan.data.current_savings}
                              displayType="text"
                              thousandSeparator
                              prefix="$"
                            />
                          }
                        </StyledBold>
                      </GoalAchievementMessage>
                      <div style={{ height: '13px' }} />
                    </GoalResult>
                    {goals.map((goal) => {
                      const expectedAge = plan.data.age + goal.years_to_expense;
                      const yearsToSave = Math.floor(goal.months_to_save) / 12;
                      const goalId = goal._id; // eslint-disable-line
                      return (
                        <GoalResult key={goalId}>
                          <SavingMessage>
                            Ahorrando{' '}
                            <StyledBold>
                              {
                                <NumberFormat
                                  value={Math.floor(goal.money_to_save)}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="$"
                                />
                              }
                            </StyledBold>{' '}
                            al mes por{' '}
                            <StyledBold>
                              {<NumberFormat value={yearsToSave} displayType="text" />}
                            </StyledBold>{' '}
                            {yearsToSave === 1 ? 'año...' : 'años...'}
                          </SavingMessage>
                          <GoalAchievementMessage>
                            Logras <StyledBold>{goal.name.replace(/_/g, ' ')}</StyledBold> a tus{' '}
                            <StyledBold>{expectedAge} años</StyledBold>
                          </GoalAchievementMessage>
                          {expectedAge + goal.late.bank.years !== expectedAge &&
                            goal.late.bank.months !== 0 && (
                              <Text type="caption" styles={StyledCaption}>
                                {goal.late.bank.years} años y {goal.late.bank.months} meses antes
                                que con el banco.
                                <StyledLink
                                  onClick={() => {
                                    mp('Metas | Modal Bank');
                                    this.toggleModalBank();
                                  }}
                                >
                                  ¿Por?
                                </StyledLink>
                              </Text>
                            )}
                          {expectedAge + goal.late.bank.years === expectedAge &&
                            goal.late.bank.months > 0 && (
                              <Text type="caption" styles={StyledCaption}>
                                {goal.late.bank.months} meses antes que con el banco.
                                <StyledLink
                                  onClick={() => {
                                    mp('Metas | Modal Bank');
                                    this.toggleModalBank();
                                  }}
                                >
                                  ¿Por?
                                </StyledLink>
                              </Text>
                            )}
                          {expectedAge + goal.late.bank.years === expectedAge &&
                            goal.late.bank.months === 0 && <div style={{ height: '13px' }} />}
                        </GoalResult>
                      );
                    })}
                    <Blank2 />
                  </GoalResults>
                </StyledFinancialMap>

                <StyledCustomDivision />

                <ResultSubsection>
                  <CTA
                    title="Quiero lograr mis metas financieras"
                    subTitle="Nosotros te decimos cómo"
                    event="Metas | Empezar ahora"
                    onClick={() => {
                      this.setState({ openConvertingModal: true });
                    }}
                  />
                </ResultSubsection>

                <ResultSubsection>
                  <Title
                    level={4}
                    styles={css`
                      align-self: center;
                    `}
                    medium
                    align="center"
                  >
                    El proceso
                  </Title>
                  <Steps
                    style={{ width: '100%' }}
                    steps={[
                      {
                        content: (
                          <Fragment>
                            Registrate
                            <Link
                              style={{ color: 'blue', marginLeft: '0.3em' }}
                              to={{
                                pathname: '/registro',
                                state: {
                                  customMessage,
                                },
                              }}
                            >
                              aquí
                            </Link>
                          </Fragment>
                        ),
                      },
                      { content: 'Conoce tus opciones' },
                      { content: 'Elige tu opción preferida' },
                    ]}
                    center
                  />
                </ResultSubsection>

                <ResultSubsection>
                  <Contact
                    title="¿Todavía con dudas?"
                    subTitle="Estamos aquí para ayudarte"
                    imgUrl="https://s3.us-east-2.amazonaws.com/finauta/art/teamSmall.png"
                    event="Metas | Conversemos"
                    onClick={() => {
                      window.fcWidget.open();
                      window.fcWidget.show();
                    }} // TODO: Cuando volvamos a utilizar las herramientas quitar el chat
                  />
                </ResultSubsection>
              </FirstSection>
            </Fragment>
          ) : (
            <Fragment>
              <Title level={1} styles={StyledCongratsTitle}>
                ¡Felicidades!
              </Title>
              <Title level={2} styles={css``}>
                <StyledUnderline>Si manejas bien tu ahorro actual</StyledUnderline>, podrás lograr
                todas tus metas.
              </Title>
              <Title level={3}>1. Conoce tus opciones de inversión</Title>
              <StyledFinancialVehiclesList>
                <StyledFinancialVehicle
                  onClick={() => {
                    mp('Metas | Modal Cetes');
                    this.toggleModalCetes();
                  }}
                >
                  <Icon icon="cetes" size={80} />
                  <Title level={5}>Cetes</Title>
                </StyledFinancialVehicle>
                <StyledFinancialVehicle
                  onClick={() => {
                    mp('Metas | Modal BolsaDeValores');
                    this.toggleModalBolsaDeValores();
                  }}
                >
                  <Icon icon="stock" color="#a5a5a5" size={80} />
                  <Title level={5}>Bolsa de valores</Title>
                </StyledFinancialVehicle>
                <StyledFinancialVehicle
                  onClick={() => {
                    mp('Metas | Modal FondoDeAhorro');
                    this.toggleModalFondoDeAhorro();
                  }}
                >
                  <Icon icon="savingsFund" size={80} />
                  <Title level={5}>Fondo de ahorro</Title>
                </StyledFinancialVehicle>
              </StyledFinancialVehiclesList>
              <Title level={3}>2. Empieza a lograr tus metas</Title>
              {FinancialAdvisors(
                customMessage,
                'Conversemos | Metas | Results',
                500,
                css`
                  margin-top: 30px;
                `,
              )}
            </Fragment>
          )}
          {plan.data.savings_periods.length > 0 ? (
            <StyledFooter>
              <QuestionSection
                questions={[
                  {
                    title: '¿Cómo que es gratis?',
                    answers: [
                      {
                        bullets: [
                          'La institución financiera que tú elijas para llevar a cabo tu plan nos  paga una comisión por haberte ayudado a encontrarla.',
                        ],
                      },
                    ],
                  },
                  {
                    title: 'Sobre tus resultados',
                    answers: [
                      {
                        bullets: [
                          'El objetivo de esta herramienta es asistirte en tu organización financiera y toma de decisiones',
                          'Los cálculos están basados en supuestos que han sido estimados y podrían no ser actuales o acertados',
                          'No tomes ninguna medida únicamente basado en la información proporcionada a través de esta herramienta',
                          <StyledLink
                            href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
                              customMessage,
                            )}`}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            Contacta a uno de nuestros asesores financieros certificados para
                            definir tu plan de ahorro personalizado
                          </StyledLink>,
                        ],
                      },
                    ],
                  },
                  {
                    title: 'Supuestos',
                    answers: [
                      {
                        subTitle: 'Escenario: tu banco',
                        bullets: [
                          'Las tasas de interés utilizadas en el análisis son las reportadas por cada banco y no incluyen cargos fijos por renovación y/o servicios adicionales',
                          'En el caso de que el usuario cuente con dos tarjetas, se paga primero la deuda de la tarjeta de crédito con mayor tasa de interés antes de realizar cualquier pago a la segunda tarjeta. Esto subestimaría el ahorro total en casos en los que la tarjeta de menor tasa de interés requiere pagos mínimos relativamente altos',
                          'Los cálculos presentados suponen que el usuario no se retrasa ni aumenta su deuda durante los meses de pago',
                        ],
                      },
                      {
                        subTitle: 'Escenario: tu mejor opción',
                        bullets: [
                          'Los resultados suponen que la totalidad de la deuda es transferida a una nueva tasa de interés especificada en la sección de resultado',
                          'Los cálculos presentados suponen que el usuario no se retrasa ni aumenta su deuda durante los meses de pago',
                        ],
                      },
                    ],
                  },
                ]}
              />
            </StyledFooter>
          ) : (
            <StyledFooter />
          )}
        </StyledResults>
      </Fragment>
    ) : (
      <StyledResults style={{ backgroundColor: 'white' }}>
        <FlowHeader>
          <WhiteLogo src={FinautaWhiteLogo} id="logo" />
        </FlowHeader>
        <FirstSection>
          {failed ? (
            <Oops
              to="/metas/empezar"
              onClick={this.forceUpdate}
              event="Metas | Resultados | Error | Empezar De Nuevo"
            />
          ) : (
            <Loading title="Tu plan personalizado estará listo en unos segundos..." />
          )}
        </FirstSection>
      </StyledResults>
    );
  }
}

Results.propTypes = {
  plan: PropTypes.object,
};

Results.defaultProps = {
  plan: {},
};

export default Results;
